import {
  SymbolLayerSpecification,
  LineLayerSpecification,
  FillLayerSpecification,
} from 'mapbox-gl'

export const createMapboxLayersStyle = ({ id }: { id: string }) => {
  const pointLayer: SymbolLayerSpecification = {
    id: `${id}-point`,
    type: 'symbol',
    source: id,
    layout: {
      'icon-image': 'dot-11', // Assuming you use a Mapbox sprite for points
      'text-field': ['get', 'user_name'],
      'text-size': 14,
      'text-anchor': 'center',
      'text-offset': [0, -1],
    },
    paint: {
      'text-color': '#ffffff',
      'text-halo-color': '#000000',
      'text-halo-width': 1,
      'icon-opacity': ['coalesce', ['get', 'user_hoverOpacity'], 1],
      'text-opacity': ['coalesce', ['get', 'user_hoverOpacity'], 1],
    },
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
      ['==', 'user_visible', true],
    ],
  }

  const lineLayer: LineLayerSpecification = {
    id: `${id}-line`,
    type: 'line',
    source: id,
    paint: {
      'line-color': [
        'coalesce',
        ['to-color', ['get', 'user_stroke']],
        '#000000',
      ],
      'line-width': ['coalesce', ['get', 'user_stroke-width'], 1],
      'line-opacity': ['coalesce', ['get', 'user_hoverOpacity'], 1],
    },
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static'],
      ['==', 'user_visible', true],
    ],
  }
  const lineLabelLayer: SymbolLayerSpecification = {
    id: `${id}-line-label`,
    type: 'symbol',
    source: id,
    layout: {
      'text-field': ['get', 'user_name'],
      'text-size': 12,
      'symbol-placement': 'line', // Ensures the text follows the line geometry
      'text-anchor': 'center',
    },
    paint: {
      'text-color': '#000000',
      'text-halo-color': '#ffffff',
      'text-halo-width': 1,
      'text-opacity': ['coalesce', ['get', 'user_hoverOpacity'], 1],
    },
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static'],
      ['==', 'user_visible', true],
    ],
  }

  const polygonLayerFill: FillLayerSpecification = {
    id: `${id}-polygon-fill`,
    type: 'fill',
    source: id,
    paint: {
      'fill-color': ['coalesce', ['to-color', ['get', 'user_fill']], '#ff4242'],
      'fill-outline-color': ['to-color', ['get', 'user_stroke'], '#ff4242'],
      'fill-antialias': false,
      'fill-opacity': ['*', 0.3, ['coalesce', ['get', 'user_hoverOpacity'], 1]],
    },
    filter: [
      'all',
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static'],
      ['==', 'user_visible', true],
    ],
  }

  const polygonLayerOutline: LineLayerSpecification = {
    id: `${id}-polygon-outline`,
    type: 'line',
    source: id,
    paint: {
      'line-color': [
        'coalesce',
        ['to-color', ['get', 'user_stroke']],
        '#ff4242',
      ],
      'line-width': ['coalesce', ['get', 'user_stroke-width'], 1],
      'line-opacity': ['coalesce', ['get', 'user_hoverOpacity'], 1],
    },
    filter: [
      'all',
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static'],
      ['==', 'user_visible', true],
    ],
  }

  // The order of the layers is important to ensure that points appear on top of lines and polygons
  return [
    polygonLayerFill,
    polygonLayerOutline,
    lineLayer,
    lineLabelLayer,
    pointLayer,
  ].map(({ source, ...layer }) => layer)
}
